module.exports = __webpack_public_path__ + "img/4.06a0ba5e.svg";